import { usersApi } from '@app/services'

import { FetchUserResponse } from './types'

export const patchUserLanguageExceptions = async (userId: number, languages: string[]): Promise<FetchUserResponse> => {
  const response = await usersApi.patch(`/users/${userId}`, {
    'user': {
      'regionalSettings': {
        'languageExceptions': languages,
      },
    }
  })
  return response.data
}